export const widthSize = {
  breakpoint320: "320px",
  breakpoint350: "350px",
  breakpoint375: "375px",
  breakpoint400: "400px",
  breakpoint481: "481px",
  breakpoint409: "409px",
  breakpoint575: "575px",
  breakpoint760: "760px",
  breakpoint767: "767px",
  breakpoint768: "768px",
  breakpoint820: "820px",
  breakpoint991: "991px",
  breakpoint1024: "1024px",
  breakpoint1025: "1025px",
  breakpoint1199: "1199px",
  breakpoint1200: "1200px",
  breakpoint1280: "1280px",
  breakpoint1300: "1300px",
  breakpoint1366: "1366px",
  breakpoint1440: "1440px",
};

export const heightSize = {
  breakpoint698: "698px",
  breakpoint760: "760px",
  breakpoint798: "798px",
  breakpoint799: "799px",
  breakpoint800: "800px",
};

export const deviceHeight = {
  breakpoint698: `(max-height: ${heightSize.mobileS})`,
  breakpoint760: `(max-height: ${heightSize.mobileS})`,
  breakpoint798: `(max-height: ${heightSize.mobileS})`,
  breakpoint799: `(max-height: ${heightSize.mobileS})`,
  breakpoint800: `(max-height: ${heightSize.mobileS})`,
};

export const deviceMinWidth = {
  breakpoint320: `(min-width: ${widthSize.breakpoint320})`,
  breakpoint350: `(min-width: ${widthSize.breakpoint350})`,
  breakpoint375: `(min-width: ${widthSize.breakpoint375})`,
  breakpoint400: `(min-width: ${widthSize.breakpoint400})`,
  breakpoint409: `(min-width: ${widthSize.breakpoint409})`,
  breakpoint481: `(min-width: ${widthSize.breakpoint481})`,
  breakpoint575: `(min-width: ${widthSize.breakpoint575})`,
  breakpoint760: `(min-width: ${widthSize.breakpoint760})`,
  breakpoint767: `(min-width: ${widthSize.breakpoint767})`,
  breakpoint768: `(min-width: ${widthSize.breakpoint768})`,
  breakpoint820: `(min-width: ${widthSize.breakpoint820})`,
  breakpoint991: `(min-width: ${widthSize.breakpoint991})`,
  breakpoint1024: `(min-width: ${widthSize.breakpoint1024})`,
  breakpoint1025: `(min-width: ${widthSize.breakpoint1025})`,
  breakpoint1199: `(min-width: ${widthSize.breakpoint1199})`,
  breakpoint1200: `(min-width: ${widthSize.breakpoint1200})`,
  breakpoint1280: `(min-width: ${widthSize.breakpoint1280})`,
  breakpoint1300: `(min-width: ${widthSize.breakpoint1300})`,
  breakpoint1366: `(max-width: ${widthSize.breakpoint1366})`,
  breakpoint1440: `(min-width: ${widthSize.breakpoint1440})`,
};

export const deviceMaxWidth = {
  breakpoint320: `(max-width: ${widthSize.breakpoint320})`,
  breakpoint350: `(max-width: ${widthSize.breakpoint350})`,
  breakpoint375: `(max-width: ${widthSize.breakpoint375})`,
  breakpoint400: `(max-width: ${widthSize.breakpoint400})`,
  breakpoint409: `(max-width: ${widthSize.breakpoint409})`,
  breakpoint481: `(max-width: ${widthSize.breakpoint481})`,
  breakpoint575: `(max-width: ${widthSize.breakpoint575})`,
  breakpoint760: `(max-width: ${widthSize.breakpoint760})`,
  breakpoint767: `(max-width: ${widthSize.breakpoint767})`,
  breakpoint768: `(max-width: ${widthSize.breakpoint768})`,
  breakpoint820: `(max-width: ${widthSize.breakpoint820})`,
  breakpoint991: `(max-width: ${widthSize.breakpoint991})`,
  breakpoint1024: `(max-width: ${widthSize.breakpoint1024})`,
  breakpoint1025: `(max-width: ${widthSize.breakpoint1025})`,
  breakpoint1199: `(max-width: ${widthSize.breakpoint1199})`,
  breakpoint1200: `(max-width: ${widthSize.breakpoint1200})`,
  breakpoint1280: `(max-width: ${widthSize.breakpoint1280})`,
  breakpoint1300: `(max-width: ${widthSize.breakpoint1300})`,
  breakpoint1366: `(max-width: ${widthSize.breakpoint1366})`,
  breakpoint1440: `(max-width: ${widthSize.breakpoint1440})`,
};
